<template>
  <div class="container">
    <v-card>
      <v-card-title class="blue accent-1 gray--text">Trazabilidad por bin</v-card-title>
      <v-card-text>
        <v-row>
            <v-col cols="3">
                <v-autocomplete
                    v-model="size"
                    :items="sizes"
                    :loading="isLoading"
                    :search-input.sync="sizeSearch"
                    color="white"
                    hide-no-data
                    hide-selected
                    item-text="name"
                    item-value="id"
                    label="Tamaño"
                    placeholder="Seleccione tamaño"
                    prepend-icon="mdi-database-search"
                    return-object
                    @change="loadBins"
                ></v-autocomplete>
            </v-col>
            <v-col cols="3">
                <v-autocomplete
                    v-model="bin"
                    :items="bins"
                    :loading="isLoading"
                    :search-input.sync="binSearch"
                    color="white"
                    hide-no-data
                    hide-selected
                    item-text="number"
                    item-value="id"
                    label="Bin"
                    placeholder="Seleccione Bin"
                    prepend-icon="mdi-database-search"
                    return-object
                    @change="loadHistory"
                ></v-autocomplete>
            </v-col>
            <v-col cols="2">
                <v-btn @click="download" color="primary">Excel</v-btn>
            </v-col>
            <v-col cols="4">
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Escriba para historial"
                    single-line
                    hide-details
                ></v-text-field>
            </v-col>
        </v-row>
        
        <v-data-table
            :headers="binsListHeaders"
            :items="binsListBody"
            class="elevation-1"
            dense
            no-data-text="No hay movimientos"
            :search="search"
        >
          <template v-slot:[`item.movement_date`]="{item}">
            {{ formatDate(item.movement_date )}}
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
  import {mapState, mapMutations} from 'vuex'

  export default {
    data: () => ({
        search: null,
        sizeSearch: null,
        binSearch: null,
        start_date: new Date().toISOString().substr(0, 10),
        isLoading: false,
        url_excel: '',
        sizes: [],
        bins: [],
        bin: {},
        size: {},
        binsListHeaders: [
        {
          text: 'Fecha Movimiento',
          align: 'center',
          sortable: true,
          value: 'movement_date',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Fecha Real',
          align: 'center',
          sortable: true,
          value: 'created_at',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Movimiento',
          align: 'center',
          sortable: true,
          value: 'type.name',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Guia',
          align: 'center',
          sortable: true,
          value: 'waybill',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Proveedor',
          align: 'center',
          sortable: true,
          value: 'company.name',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Planta',
          align: 'center',
          sortable: true,
          value: 'facility.name',
          class: "salmon black--text elevation-3"
        },
      ],
      binsListBody: [],
    }),
    mounted() {
      this.loadSizes();
    },
    methods:{
      async loadSizes(){
        let url = `${this.base_url}sizes`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.sizes = response.data.data;
        }).catch((error)=>{
            console.log(error);
        });
      },
      async loadBins(){
        let url = `${this.base_url}bins/bysize/${this.size.id}`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.bins = response.data.data;
        }).catch((error)=>{
            console.log(error);
        });
      },
      async loadHistory(){
        this.mostrarLoading('Generando informe, por favor espere...');
        let url = `${this.base_url}bins/trazabilidad/${this.bin.id}`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.binsListBody = response.data.data.report_data;
            this.url_excel = this.storage_url + response.data.data.url_excel;
            this.ocultarLoading();
        }).catch((error)=>{
            console.log(error);
            this.ocultarLoading();
        });
      },
      download(){
        window.location.href = this.url_excel;
      },
      formatDate (date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${day}-${month}-${year}`
      },
      ...mapMutations(['actualizarBaseUrl', 'actualizarUrlStorage', 'mostrarLoading', 'ocultarLoading']),
    },
    computed:{
      ...mapState(['authenticated', 'loading', 'base_url', 'storage_url', 'headers'])
    },
    components:{
    }
  }
</script>